import React, { type PropsWithChildren, type ReactNode } from "react";
import { overrideTailwindClasses } from "tailwind-override";

type RtrPillProps = PropsWithChildren<{
  className?: string;
  icon?: ReactNode;
  onClick?: () => void;
  href?: string;
  role?: "submit" | "button" | "reset";
  text: string;
  dataHeapId?: string;
  dataTestId?: string;
}>;

const RtrPill = ({
  className = "",
  icon,
  onClick,
  href,
  text,
  role,
  dataHeapId,
  dataTestId,
  children,
}: RtrPillProps) => {
  const renderIcon = () => {
    if (!icon) {
      return null;
    }

    return <div className={"mr-2"}>{icon}</div>;
  };

  const baseClasses = "rounded-3xl px-3 m-1 h-8 flex items-center justify-center text-sm";
  const classNames = overrideTailwindClasses(`${baseClasses} ${className}`);

  if (href) {
    return (
      <a className={classNames} href={href} role={role} data-heap-id={dataHeapId} data-test-id={dataTestId}>
        {renderIcon()}
        <span className="test-sm">{text}</span>
        {children}
      </a>
    );
  }

  return (
    <button className={classNames} onClick={onClick} role={role} data-heap-id={dataHeapId} data-test-id={dataTestId}>
      {renderIcon()}
      <span className="test-sm">{text}</span>
      {children}
    </button>
  );
};

export default RtrPill;
